import { useSearchParams } from "react-router-dom";
import { Phone, MessageCircle, Mail, MapPin } from "lucide-react";
import { useLang } from "../lib/lang";
import { pages } from "../lib/pagesCopy";
import { useSeo } from "../lib/seo";
import { PHONE, WA_DEFAULT } from "../lib/copy";
import { BUSINESS } from "../config/business";
import { trackWhatsApp, trackCall } from "../lib/analytics";
import { PageHero } from "../components/PageHero";
import { Faq, Enquiry } from "../components/Contact";

const ContactCards = ({ c }) => {
  const cards = [
    { key: "call", Icon: Phone, label: c.call, value: PHONE, href: `tel:+91${PHONE}`, onClick: () => trackCall("contact-page") },
    { key: "whatsapp", Icon: MessageCircle, label: c.whatsapp, value: PHONE, href: WA_DEFAULT, external: true, onClick: () => trackWhatsApp("contact-page") },
    { key: "email", Icon: Mail, label: c.email, value: BUSINESS.email, href: `mailto:${BUSINESS.email}` },
    { key: "visit", Icon: MapPin, label: c.visit, value: BUSINESS.address },
  ];
  return (
    <section className="relative z-10 -mt-12 pb-4" data-testid="contact-cards">
      <ul className="mx-auto grid max-w-7xl gap-3 px-5 sm:grid-cols-2 sm:px-8 lg:grid-cols-4 lg:gap-5">
        {cards.map(({ key, Icon, label, value, href, external, onClick }) => {
          const body = (
            <>
              <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-sun text-night"><Icon className="h-5 w-5" aria-hidden="true" /></span>
              <span className="min-w-0">
                <span className="block font-display text-xs font-bold uppercase tracking-[0.18em] text-night/70">{label}</span>
                <span className="mt-1 block break-words font-display text-base font-extrabold text-ink">{value}</span>
              </span>
            </>
          );
          const cls = "flex h-full items-center gap-4 rounded-[1.25rem] border border-ink/10 bg-white p-5 shadow-[0_20px_40px_-30px_rgba(18,24,63,0.5)] transition-transform duration-300 hover:-translate-y-0.5 lg:flex-col lg:items-start lg:p-6";
          return (
            <li key={key}>
              {href
                ? <a href={href} onClick={onClick} target={external ? "_blank" : undefined} rel={external ? "noopener noreferrer" : undefined} className={cls} data-testid={`contact-card-${key}`}>{body}</a>
                : <div className={cls} data-testid={`contact-card-${key}`}>{body}</div>}
            </li>
          );
        })}
      </ul>
    </section>
  );
};

export default function ContactPage() {
  const { lang } = useLang();
  const c = pages[lang].contact;
  const [params] = useSearchParams();
  useSeo({ title: "Contact Mirai Educations | Free Admission Counselling, Lucknow", description: "Call or WhatsApp 7311101115, email support@miraieducations.com, or send an enquiry for free online and distance degree counselling. Office in Ashiyana, Lucknow.", path: "/contact" });
  return (
    <main data-testid="contact-page">
      <PageHero eyebrow={c.eyebrow} title={c.title} text={c.text} testid="contact-hero" />
      <ContactCards c={c.cards} />
      <Enquiry programme={params.get("programme") || ""} />
      <Faq />
    </main>
  );
}
